import React from 'react'
import {QueryClient, QueryClientProvider} from 'react-query'

export const ReactQueryProvider = ({children, queryClient = null}) => {
  return (
    <QueryClientProvider client={queryClient ?? new QueryClient()}>{children}</QueryClientProvider>
  )
}
